"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var configuration_1 = require("./configuration");

var validation_1 = require("../../validation");

var SelectedTroughKeys;

(function (SelectedTroughKeys) {
  SelectedTroughKeys["Qty"] = "qty";
  SelectedTroughKeys["Trough"] = "trough";
})(SelectedTroughKeys = exports.SelectedTroughKeys || (exports.SelectedTroughKeys = {}));

var SelectedTrough =
/** @class */
function (_super) {
  __extends(SelectedTrough, _super);

  function SelectedTrough() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SelectedTrough.prototype.handle = function () {
    var _this = this;

    if (this.prevKey && this[this.prevKey] === null) {
      return null;
    }

    var data = {};
    Object.keys(SelectedTroughKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[SelectedTroughKeys[key]] = _this[SelectedTroughKeys[key]], _a));
    });
    return data;
  };

  SelectedTrough.prototype.handleDefaults = function () {
    var data = this.handle();

    if (!data) {
      return validation_1.createError({
        msg: '{{selectedTrough}} not present',
        code: 'TROUGH_NOT_PRESENT',
        inObject: 'selectedTrough.qty',
        statusCode: 400
      });
    }

    if (!data.trough) {
      return validation_1.createError({
        msg: 'Failed to load trough',
        code: 'TROUGH_NOT_PRESENT',
        inObject: 'selectedTrough.qty',
        statusCode: 400
      });
    }

    if (data.qty === 0) {
      return validation_1.createError({
        msg: '{{qty}} should be greater then 0',
        code: 'QTY_TO_SMALL',
        inObject: 'selectedTrough.qty',
        statusCode: 400
      });
    }

    return {
      qty: this.qty,
      troughId: data.trough.id.toString()
    };
  };

  Object.defineProperty(SelectedTrough.prototype, "qty", {
    get: function get() {
      if (!this.selectedTrough) {
        return this.getDefault(configuration_1.ConfigurationKeys.SelectedTrough, SelectedTroughKeys.Qty);
      }

      return this.selectedTrough.qty;
    },
    enumerable: true,
    configurable: true
  });
  return SelectedTrough;
}(configuration_1.Configuration);

exports.SelectedTrough = SelectedTrough;